/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePersonalFormStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    maxWidth: '360px',
  },
  buttons: {
    padding: '20px 0',
    position: 'sticky',
    background: 'rgba(255,255,255,0.8)',
    bottom: '0',
    display: 'flex',
    margin: '0 -7px',
  },
  buttonWrap: {
    padding: '0 7px',
  },
  errorBlock: {
    fontSize: '15px',
    lineHeight: '16px',
    padding: '0 19px',
    color: '#FA634E',
    marginTop: '16px',
  },
}));

export const useFormsStyles = makeStyles(() => ({
  addressForm: {
    margin: '40px 0 20px 0',
  },
  twoEqualFields: {
    display: 'flex',
    width: '100%',
    '& > *': {
      flex: 1,
      '&:not(:first-child)': {
        marginLeft: '20px',
      },
    },
  },
  phone: {
    display: 'flex',
    '& > *:not(:first-child)': {
      marginLeft: '10px',
      width: 'auto',
      flex: '1',
    },
    '& > *:first-child': {
      width: '135px',
    },
  },
  flagIcon: {
    width: '26px !important',
    height: '18px !important',
  },
}));
